import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Savedcity
const GQLAddSavedcity = gql`
  mutation addsavedcitybyuser(
    $userId: String
    $name: String
    $savedDate: String
    $updatedDate: String
    $savedStatus: Int
  ) {
    createsavedcitybyuser(
      userId: $userId
      name: $name
      savedDate: $savedDate
      updatedDate: $updatedDate
      savedStatus: $savedStatus
    ) {
      success
      message
    }
  }
`;

//Update Savedcity
const GQLUpdateSavedcity = gql`
  mutation updateSavedcity($id: String!, $name: String) {
    Updatesavedneighborhoodbyuser(id: $id, name: $name) {
      success
      message
    }
  }
`;

//Delete Savedcity
const GQLDeleteSavedcity = gql`
  mutation deleteSavedcity($id: String!) {
    deletesavedneighborhoodbyuser(id: $id) {
      success
      message
    }
  }
`;

//Get All User
const QUERY_getAllSavedcityList = gql`
  query getsavedcitybyuser(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getsavedcitybyuser(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      name
      areatype
      label
      level
      neighborhoodtype
      census_id
      census_name
      place_id
      place_name
      postalcity_id
      postalcity_name
      county_id
      county_name
      state_id
      state_name
      latitude
      longitude
      geometrytype
      npi
      personal
      value
      school
      crime
      walkability
      publicspaces
      curb
      others
      centroid
      keyword
      npiAreaRanking
      npiCityRanking
      reviewOneLiner
      reviewSummary
      similarneighborhoodIds
      cityImages {
        imageurl
      }
      cityaverage {
        totalnpi
        npisore
        personalscore
        valuescore
        schoolscore
        crimescore
        walkscore
        comscore
        crubscore
        otherscore
        medianpricescore
        primaryscore
        middlescore
        highscore
      }
      walkscorestatus
      primaryschoolscore
      middleschoolscore
      highschoolscore
      medianprice
      personalNpi
      savedDate
      updatedDate
      userId
      cityfullname
      nhfullname
      cityreview
    }
  }
`;

const QUERY_checkSavedcitybyuserStatus = gql`
  query checkSavedcitybyuserStatus($userId: String, $name: String) {
    checkSavedcitybyuserStatus(userId: $userId, name: $name) {
      id
      userId
      name
      savedDate
      updatedDate
      savedStatus
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addsavedcitybyuser(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddSavedcity,
        variables: {
          userId: adddata.userId,
          name: adddata.name,
          savedDate: adddata.savedDate,
          updatedDate: adddata.updatedata,
          savedStatus: adddata.savedStatus,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updatesavedneighborhoodbyuser(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateSavedcity,
        variables: {
          id: updatedata.id,
          name: updatedata.name,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deletesavedneighborhoodbyuser(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteSavedcity,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllsavedncitybyuserList(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllSavedcityList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function checkSavedcitybyuserStatus(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_checkSavedcitybyuserStatus,
        options: {
          fetch: fetch,
        },
        variables: {
          userId: getdata.userId,
          name: getdata.name,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addsavedcitybyuser,
  updatesavedneighborhoodbyuser,
  deletesavedneighborhoodbyuser,
  getAllsavedncitybyuserList,
  checkSavedcitybyuserStatus,
};
